import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Edit } from 'react-feather';
import { FormattedMessage } from 'react-intl';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { ActionButton, CancelButton } from 'components/ui/Button';
import ADD_VOUCHER_NOTE from './mutations/ADD_VOUCHER_NOTE';

import {
  StyledForm,
  StyledTextArea,
  StyledLinkButton,
  TextAreaContainer,
  ErrorMessage,
  StyledButtonWrapper
} from './AddVoucherNoteForm.styles';

const AddVoucherNoteForm = ({ voucherAlias, refetchVoucherNotes }) => {
  const { register, handleSubmit, formState } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      message: ''
    }
  });

  const [isFormOpened, toggleFormOpened] = useState(false);
  const [hasError, setError] = useState(false);

  const [addVoucherNote, { loading }] = useMutation(ADD_VOUCHER_NOTE);

  const toggleForm = (value) => {
    setError(false);
    toggleFormOpened(value);
  };

  const onSubmit = async (formData) => {
    try {
      await addVoucherNote({
        variables: {
          voucherAlias,
          message: formData.message
        }
      });
      refetchVoucherNotes();
      toggleForm(false);
    } catch (err) {
      setError(true);
    }
  };

  return (
    <>
      {!isFormOpened && (
        <StyledLinkButton data-cy="notes-add-new-link" onClick={() => toggleForm(true)}>
          <Edit />
          <FormattedMessage id="notes.new" />
        </StyledLinkButton>
      )}

      {isFormOpened && (
        <StyledForm data-cy="notes-add-new-form" onSubmit={handleSubmit(onSubmit)}>
          <TextAreaContainer>
            <StyledTextArea
              data-cy="voucher-note-message"
              {...register('message', {
                required: true
              })}
              id="voucher-note-message"
            />
          </TextAreaContainer>
          {hasError && (
            <ErrorMessage>
              <FormattedMessage id="vouchers.addNoteFailed" />
            </ErrorMessage>
          )}
          <StyledButtonWrapper>
            <ActionButton type="submit" data-cy="add-voucher-note-submit" loading={loading} disabled={loading || !formState.isValid}>
              <FormattedMessage id="notes.add" />
            </ActionButton>
          </StyledButtonWrapper>
          <StyledButtonWrapper>
            <CancelButton type="button" data-cy="add-voucher-note-cancel" onClick={() => toggleForm(false)}>
              <FormattedMessage id="vouchers.cancel" />
            </CancelButton>
          </StyledButtonWrapper>
        </StyledForm>
      )}
    </>
  );
};

AddVoucherNoteForm.propTypes = {
  voucherAlias: PropTypes.string.isRequired,
  refetchVoucherNotes: PropTypes.func
};

export default AddVoucherNoteForm;
